import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
globalThis.Pusher = Pusher;

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;

if (reverbKey) {
    globalThis.Echo = new Echo({
        broadcaster: 'reverb',
        key: reverbKey,
        wsHost: import.meta.env.VITE_REVERB_HOST || globalThis.location.hostname,
        wsPort: import.meta.env.VITE_REVERB_PORT || (import.meta.env.VITE_REVERB_SCHEME === 'https' ? 443 : 80),
        wssPort: import.meta.env.VITE_REVERB_PORT || 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    });
} else {
    globalThis.Echo = null;
}

/**
 * Listen for realtime notifications on the user's private channel.
 * Dispatches a custom DOM event that notification components can listen to.
 */
function setupNotificationChannel() {
    // Try to get user ID from Inertia page props embedded in the DOM
    const pageEl = document.getElementById('app');
    if (!pageEl) return;

    try {
        const pageData = JSON.parse(pageEl.dataset.page || '{}');
        const userId = pageData?.props?.auth?.user?.id;

        // Store page props globally for notification click handlers
        globalThis.__inertiaPageProps = pageData?.props;

        if (!userId || !globalThis.Echo) return;

        // Avoid duplicate subscriptions
        if (globalThis.__notifChannelUserId === userId) return;
        globalThis.__notifChannelUserId = userId;

        globalThis.Echo.private(`user.${userId}`)
            .listen('.NewChatNotification', (data) => {
                globalThis.dispatchEvent(new CustomEvent('new-notification', { detail: data }));
            });
    } catch (e) {
        // Silently fail if page data isn't available yet
    }
}

// Run on initial load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNotificationChannel);
} else {
    setupNotificationChannel();
}

// Re-run on Inertia page navigations
document.addEventListener('inertia:page', (event) => {
    globalThis.__inertiaPageProps = event?.detail?.page?.props;
    setupNotificationChannel();
});
